module.exports = __webpack_public_path__ + "img/63.1009164c.svg";